/**
 * 组件库入口文件
 * 
 * 使用前需先安装并引入依赖：
 *   import ElementUI from 'element-ui'
 *   import 'element-ui/lib/theme-chalk/index.css'
 *   import Antd from 'ant-design-vue'
 *   import 'ant-design-vue/dist/antd.css'
 *   import wDesignUi from 'w-design-ui'
 *   import 'w-design-ui/w-design-ui.css'
 *   Vue.use(ElementUI)
 *   Vue.use(Antd)
 *   Vue.use(wDesignUi)
 * 
 * 使用方式：
 *   import DeliveryPlatform from 'delivery-platform-project'
 *   Vue.use(DeliveryPlatform)
 */

// 组件
import ProjectIndex from './deliveryPlatformProject'

// 工具
import platformApi from './axios'
import './utils/tips'

// 组件列表
const components = [
  ProjectIndex
]

// 全量注册
const install = (Vue) => {
  if (install.installed) return
  install.installed = true
  
  components.forEach(component => {
    Vue.component(component.name, component)
  })
}

// 支持按需引入
export {
  ProjectIndex,
  platformApi
}

// 支持 Vue.use() 全量引入
export default {
  install
}
